import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { editActions, editMutations } from './types';
import { NAME, CRUMB_LABEL_KEY, DEPENDENT_TABLES as depTableNames, SERVISNI_PAKETY_ND, SERVISNI_PAKETY_DRUH, SERVISNI_PAKETY_PP } from '../constants';
import { apiProvider } from '../api';

const edit = {
	SnNr: null as number | null,
	PlatnostDat: null as Date | null,
	PlatnostdoDat: null as Date | null,
	Text: null as string | null,
	Tablpozice: null as number | null,
	TablpoziceText: null as string | null,
	ZakazkaPcMin: null as number | null,
	Labels: null as string[] | null,
	VyrobekvozOzn: null as string | null,
	SlevaMat: null as number | null,
	SlevaSlz: null as number | null,
	SnzdrojdatPzn: null as number | null,
	KdVerze: null as number | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
	},
	depTableNames,
	depTableSettings: {
		[SERVISNI_PAKETY_DRUH]: {
			filter(state) {
				return {
					SnzdrojdatPzn: state.edit.SnzdrojdatPzn,
					KdVerze: state.edit.KdVerze,
					SnNr: state.edit.SnNr,
					VyrobekvozOzn: state.edit.VyrobekvozOzn,
				};
			},
		},
		[SERVISNI_PAKETY_ND]: {
			filter(state) {
				return {
					SnzdrojdatPzn: state.edit.SnzdrojdatPzn,
					KdVerze: state.edit.KdVerze,
					SnNr: state.edit.SnNr,
					VyrobekvozOzn: state.edit.VyrobekvozOzn,
				};
			},
		},
		[SERVISNI_PAKETY_PP]: {
			filter(state) {
				return {
					SnzdrojdatPzn: state.edit.SnzdrojdatPzn,
					KdVerze: state.edit.KdVerze,
					SnNr: state.edit.SnNr,
					VyrobekvozOzn: state.edit.VyrobekvozOzn,
				};
			},
		},
	},
	edit,
	localState: {},
	extraActions: {
		[editActions.SERVISNI_PAKETY_DRUH]: async ({ state, commit, dispatch }, data) => {
			apiProvider.addDruhSP(data);
		},
	},
	extraMutations: {
		[editMutations.TABULKOVA_POZICE_SELECT_MAPPER_EDIT](state, { data }) {
			state.edit.Tablpozice = data.value;
			state.edit.TablpoziceText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
